import { render, staticRenderFns } from "./Approach.vue?vue&type=template&id=2faf410c&scoped=true&"
var script = {}
import style0 from "./Approach.vue?vue&type=style&index=0&id=2faf410c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faf410c",
  null
  
)

export default component.exports